// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:767.98px){.obj-button[data-v-633e000a]{border:2px solid #fff}}", ""]);
// Exports
module.exports = exports;
